var OCS = OCS || {};
OCS.Data = OCS.Data || {};
OCS.Data.Geometry = OCS.Data.Geometry || {};
OCS.Geometry = OCS.Geometry || {};
OCS.Geometry.Classes = OCS.Geometry.Classes || {};
OCS.Geometry.Functions = OCS.Geometry.Functions || {};
OCS.Geometry.Functions.define_GeoJsonFeatureData_class = function (in_implements) {
    var implements = [Options, Events, new Class(OCS.Interfaces.BaseData)];
    /* istanbul ignore if */
    if (in_implements && in_implements.length) {
        implements.combine(in_implements);
    }
    return new Class({
        Implements: implements,
        class_type: "Data",
        class_name: "GeoJsonFeatureData",
        data_type: 'GeoJsonFeatureData',
        options: {
            type: 'Feature',
            properties: {
                simplified: 0,
                sid: "",
                table: "",
                table_id: 0
            },
            geometry: {
                type: "",
                coordinates: []
            },
            crs: {
                type: "",
                properties: {}
            }
        },
        initialize: function (op) {
            if(!op) {
                return false;
            }

            if(op.id || op.sid) {
                var sid;
                if(op.id) {
                    sid = op.id;
                    delete op.id;
                }
                if(op.sid) {
                    sid = op.sid;
                    delete op.sid;
                }
                if(!op.properties) {
                    op.properties = {"sid": sid};
                } else {
                    op.properties.sid = sid;
                }
            }

            if(op.crs) {
                op.crs = OCS.Geometry.Functions.getCrsProjectionName(op.crs);
            }
            this.setOptions(op);
            return OCS.Geometry.Functions.AddGeometry(this);

        },
        get_crs_name: function() {
            return this.options.crs.properties.name;
        },
        get_data_type: function () {
            return this.options.type;
        },
        get_feature: function() {
            return this.options;
        },
        get_geometry: function() {
            return this.options.geometry;
        },
        get_sid: function () {
            return this.options.properties.sid;
        },
        set_sid: function(sid) {
            this.options.properties.sid = sid;
        },
        get_key: function() {
            return OCS.Geometry.Functions.getKey(this.options.properties.sid, this.options.crs.properties.name, parseInt(this.options.properties.simplified));
        },
        get_properties: function() {
            return this.options.properties;
        }
    });
};
OCS.Geometry.Classes.GeoJsonFeatureData = OCS.Geometry.Functions.define_GeoJsonFeatureData_class();
